<template>
    <div class="areas_info">
        <div class="columns">
            <div class="column"><h1>Информация о площадках - ДНИ КОРОТКОМЕТРАЖНОГО КИНО-2024</h1></div>
        </div>


        <!--				 && region.length === 0 && city.length === 0-->
        <template v-if="!loading">

						<div class="columns">
                <div class="column">
                    <p class="before_select">Выберите страну</p>
                    <Select
                            v-model:value="country"
                            placeholder="Выберите"
														size="middle"
                            :allowClear="true"
                            style="width: 100%"
                            :options="countries_list"
                    ></Select>
								</div>
                <div class="column">
                    <p class="before_select">Выберите регион</p>
                    <Select
                            v-model:value="region"
                            size="middle"
                            :allowClear="true"
                            style="width: 100%"
                            placeholder="Выберите"
                            :disabled="isRegionDisabled"
                            :options="regions_list"
                    ></Select>
								</div>
                <div class="column">
                    <p class="before_select">Выберите населенный пункт</p>
                    <Select
                            v-model:value="punkt"
                            size="middle"
                            placeholder="Выберите"
                            :allowClear="true"
                            style="width: 100%"
                            :disabled="isPunktDisabled"
                            :options="cites_selos_list"
                    ></Select>
								</div>
						</div>
	        
            <template v-if="step === 'areas'">

                <div class="columns">
                    <div class="column">
                        <div class="areas_shows_wrapper" v-if="paginatedAreas.length > 0">

														<div class="stat_block_area"><span style="color: rgba(0, 0, 0, 0.50);">Показано площадок:</span> {{ areas_to_filter.length }}</div>

                            <div class="area_show_wrapper" v-for="(area,index) in paginatedAreas" :key="index">

                                <div class="columns" >
                                    <div class="column is-narrow" style="display: flex; align-items: center; justify-content: center; ">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="35" viewBox="0 0 28 35" fill="none">
                                            <path d="M14 0C6.268 0 0 6.26811 0 14C0 21.732 14 35 14 35C14 35 27.9999 21.732 27.9999 14C27.9999 6.26811 21.7319 0 14 0ZM14 3.81823C15.3371 3.81823 16.6611 4.0815 17.8964 4.59318C19.1317 5.10486 20.2541 5.85483 21.1996 6.80029C22.145 7.74576 22.895 8.86824 23.4067 10.1036C23.9184 11.3389 24.1818 12.6629 24.1817 14C24.1818 15.3371 23.9184 16.661 23.4067 17.8964C22.895 19.1317 22.145 20.2541 21.1996 21.1996C20.2541 22.1451 19.1317 22.895 17.8964 23.4067C16.6611 23.9184 15.3371 24.1818 14 24.1818C12.6629 24.1818 11.3389 23.9184 10.1036 23.4067C8.86824 22.895 7.74581 22.1451 6.80034 21.1996C5.85488 20.2541 5.10489 19.1317 4.59321 17.8964C4.08153 16.661 3.81817 15.3371 3.81817 14C3.81817 12.6629 4.08153 11.3389 4.59321 10.1036C5.10489 8.86824 5.85488 7.74576 6.80034 6.80029C7.74581 5.85483 8.86824 5.10486 10.1036 4.59318C11.3389 4.0815 12.6629 3.81823 14 3.81823Z" fill="#EC983F"/>
                                            <path d="M17.7057 7.58567C17.6488 7.58449 17.5919 7.5911 17.5367 7.60505L9.51754 9.61105C9.43261 9.62743 9.35192 9.66094 9.28038 9.70955C9.20884 9.75816 9.14796 9.82085 9.10146 9.89378C9.05496 9.96671 9.02381 10.0484 9.00991 10.1338C8.99602 10.2192 8.99967 10.3063 9.02065 10.3903C9.04162 10.4742 9.07948 10.553 9.13192 10.6218C9.18435 10.6905 9.25025 10.748 9.3256 10.7904C9.40095 10.8329 9.48416 10.8596 9.57016 10.8688C9.65616 10.878 9.74313 10.8695 9.82578 10.844L17.8449 8.83801C17.9958 8.80189 18.1282 8.71196 18.2174 8.58507C18.3066 8.45819 18.3464 8.30309 18.3293 8.14894C18.3122 7.99478 18.2394 7.85215 18.1246 7.74788C18.0098 7.64362 17.8608 7.58786 17.7057 7.58567Z" fill="#EC983F"/>
                                            <path d="M9.22955 12.0909V13.6817H18.775V12.0909H9.22955Z" fill="#EC983F"/>
                                            <path d="M9.22955 14.9547V18.3553C9.22955 18.7622 9.55546 19.091 9.9554 19.091H18.0516C18.4516 19.091 18.775 18.762 18.775 18.3553V14.9547H9.22955Z" fill="#EC983F"/>
                                        </svg>
																		</div>
                                    <div class="column">
                                        <h3 class="area_name">{{ area.data.area_name }}</h3>
                                        <p class="area_address" v-if="area.data.area_address">{{getAreaAddress(area) }}</p>
																		</div>
                                </div>


                                <Table
                                        :data-source="get_filtered_shows(area)"
                                        :columns="columns"
                                        :show-header="false"
                                        :pagination="false"
                                        bordered
                                >
                                    <template #bodyCell="{ column, record }">

                                        <template v-if="column.key === 'date'">
																						<span class="date_format">{{ getFormatedDate(record.date) }}</span><br>
                                            <span class="time_format">{{ getFormatedTime(record.date) }}</span>

<!--																						{{ record.date }}-->
																				</template>

                                        <template v-if="column.key === 'show_programm'">
																						<div class="programm_description_wrapper" style="">
                                                <span>{{ record.show_programm}}</span>

																						</div>
                                        </template>
																				<template v-if="column.key === 'show_is_online'">
                                            <div class="programm_description_wrapper" style="justify-content: center">
                                            <span class="type_show_online" v-if="record.show_is_online">Онлайн</span>
                                            <span class="type_show_offline" v-else>Офлайн</span>
																						</div>
                                        </template>
                                    </template>
                                </Table>
                            </div>
                        </div>
                        <div v-else>
                            <p>Ничего не найдено</p>
                        </div>

												<Pagination
													:current="current"
													:pageSize="pageSize"
													:total="areas_to_filter.length"
													@change="handlePageChange"
													@showSizeChange="handleSizeChange"
													:pageSizeOptions="['10', '20', '50', '100']"
												></Pagination>
										</div>
                </div>
            </template>
        </template>
        <template v-else>
            <Spin></Spin>
        </template>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import {RadioGroup, Checkbox, Select, Radio, Table, Spin, Pagination} from "ant-design-vue";

export default {
  name: 'AreasInfo',
  data() {
    return {
      country: undefined,
      region: undefined,
      city: '',
      selo: '',
			punkt: undefined,
			current: 1,
      pageSize: 10,
      areas: [],
      type_area: '',
      loading: false,
      selo_gorod: '',
      countries: [],
      regions: [],
      cities: [],
      cites_selos: {
        cities: [],
        selos: []
      },
      selos: [],
      columns: [
        {
          title: 'Дата показа',
          dataIndex: 'date',
          key: 'date',
          width: "110px"
        },
        {
          title: 'Программа',
          dataIndex: 'show_programm',
          key: 'show_programm',
        },
        {
          title: 'Вид показа',
          dataIndex: 'show_is_online',
          key: 'show_is_online',
					width: "130px"
        }
      ],
      selo_filter: true,
      city_filter: true,
      areas_loaded: false,
      step: ''
    }
  },
  components: {
    RadioGroup,
    Radio,
    Table,
    Select,
    Spin,
    Checkbox,
    Pagination
  },
  created: function () {
    this.getCountries();
    this.getAreas();

    //this.country = 'Российская Федерация';
    //this.region = 'Владимирская область';
    //this.punkt = 'Гусь-Хрустальный'
  },
  methods: {
    async getCountries() {
      this.isLoading = true;
      const response = await axios.get('/get_areas_countries');
      this.countries = response.data;
      this.isLoading = false;
    },
    async getRegions() {
      this.isLoading = true;
      const response = await axios.post('/get_areas_regions', null, {
        params: {
          country: this.country
        }
      })
      this.regions = response.data;
      this.isLoading = false;
    },

    async getCitiesAndSelos() {
      this.isLoading = true;

      const response = await axios.post('/get_areas_cities_and_selos', null, {
        params: {
          country: this.country,
          region: this.region
        }
      })
      this.cites_selos = response.data;
      this.isLoading = false;
    },
    async getCities() {
      this.isLoading = true;

      const response = await axios.post('/get_areas_cities', null, {
        params: {
          country: this.country,
          region: this.region
        }
      })
      this.cities = response.data;

      this.isLoading = false;
    },
    async getSelos() {
      this.isLoading = true;

      const response = await axios.post('/get_areas_selos', null, {
        params: {
          country: this.country,
          region: this.region
        }
      })
      this.selos = response.data;

      this.isLoading = false;
    },
    async getAreas() {
      this.isLoading = true;

      const response = await axios.post('/get_areas_by_params', null, {
        params: {
          country: this.country,
          region: this.region,
          city: this.city,
          selo: this.selo
        }
      })
      this.areas = response.data;
      //this.areas_to_filter = this.areas;
      this.areas_loaded = true;
      this.step = 'areas';

      this.isLoading = false;
    },
	  handleSizeChange(current, size) {
		  this.pageSize = size;
		  this.current = 1; // Сбрасываем на первую страницу при изменении размера
	  },
		getFormatedDate(date) {
      return moment(date).format('DD.MM.YYYY')
		},
		getFormatedTime(date) {
      return moment(date).format('HH:mm')
		},
    selectCountry(country_item) {
      this.country = country_item;
      if (this.country !== 'Российская Федерация') {
        this.region = '-';
        this.getCitiesAndSelos();
        this.step = 'city_selo';
      } else {
        this.getRegions()
        this.step = 'region';
      }
    },
    back_from_type() {
      this.region = '';
      if (this.country !== 'Российская Федерация') {
        this.regions = [];
        this.country = '';
      }
    },
    selectCitySelo(item) {
      this.city = '';
      this.selo = '';
      if (item) {
        if (item.type === 'city') {
          this.city = item.value;
        }
        if (item.type === 'selo') {
          this.selo = item.value;
        }
        //this.getAreas();
      } else {
        //this.areas = [];
			}
    },
    handlePageChange(page) {
      this.current = page;
		},
    getSortedShows(shows) {
      // console.log(shows, shows.sort((a, b) => {
      //   return new Date(a.date) - new Date(b.date);
      // }));
      return shows.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
		},
    get_filtered_shows(area) {
      let res = [];
      if (area.data?.shows && area.data?.shows.length > 0) {
        this.getSortedShows(area.data?.shows).forEach((show) => {
          const date = moment(show.date);
          if (date.isSameOrAfter('2023-03-01')) {
            show.date = date.format('YYYY-MM-DD HH:mm')
            res.push(show)
          }
        })
      }
      return res;
    },
    getAreaAddress(area) {
			let punkt = '';
      if (area.data.poselok && area.data.poselok.length > 0) {
        punkt = area.data.poselok + ',';
			}
      if (area.data.city && area.data.city.length > 0) {
        punkt = area.data.city + ',';
      }
      return punkt + ' ' + area.data.area_address
    }
  },
  computed: {
		countries_list() {
      return this.countries.map((country) => {
        return {
          value: country
				}
			})
		},
    regions_list() {
      return this.regions.map((region) => {
        return {
          value: region
        }
      })
    },
    isRegionDisabled() {
      let res = false;
      if ((this.country !== undefined && this.country.length === 0) || (this.country !== undefined && this.country.length > 0 && this.country !== 'Российская Федерация') || this.country === undefined) {

        res = true;
      }

      return res;
    },
		isPunktDisabled() {
      let res = false;
      if ((this.region !== undefined && this.region.length === 0) || this.region === undefined) {
        res = true;
      }
      return res;
		},
    cites_selos_all() {
      let cities = [];
      let selos = [];
      if (this.city_filter) {
        this.cites_selos.cities.forEach(city => {
          cities.push({name: city, type: 'city'})
        });
      }
      if (this.selo_filter) {
        this.cites_selos.selos.forEach(selo => {
          selos.push({name: selo, type: 'selo'})
        });
      }
      return cities.concat(selos)
    },
    cites_selos_list() {
      let cities = [];
      let selos = [];
      if (this.city_filter) {
        this.cites_selos.cities.forEach(city => {
          cities.push({value: city, type: 'city'})
        });
      }
      if (this.selo_filter) {
        this.cites_selos.selos.forEach(selo => {
          selos.push({value: selo, type: 'selo'})
        });
      }
      return cities.concat(selos)
    },
    areas_to_filter() {
      let res = this.areas;
      if (this.country && this.country.length > 0) {
        res = res.filter((item) => {
          return item.data.country === this.country;
				})
			}
      if (this.region && this.region.length > 0) {
        res = res.filter((item) => {
          return item.data.region === this.region;
        })
      }
      if (this.punkt && this.punkt.length > 0) {
        res = res.filter((item) => {
          return item.data.city === this.punkt || item.data.poselok === this.punkt;
        })
			}
			return res;
		},
    paginatedAreas() {
      const start = (this.current - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.areas_to_filter.slice(start, end);
		}
  },
  watch: {
    country(val) {
      this.current = 1;
      this.region = '';
      if (val === undefined) {
        this.country = '';
      }
      else {
        if (val.length > 0) {
          if (val !== 'Российская Федерация') {
            this.region = '-';
            this.getCitiesAndSelos();
            //this.step = 'city_selo';
          }
          else {
            this.getRegions()
            //this.step = 'region';
            this.punkt = '';
          }
				}
        else {
          this.region = '';
          this.punkt = '';
				}
			}
		},
    selo_gorod(val) {
      if (val === 'selo') {
        this.getSelos();
      } else if (val === 'city') {
        this.getCities();
      }
    },
    region(val) {
      this.current = 1;
      if (val === undefined) {
        this.region = '';
        this.punkt = '';
        //this.areas = [];
      }
      else {
        this.punkt = '';
        this.getCitiesAndSelos();
			}
    },
    punkt(val) {
      this.current = 1;
      const select = this.cites_selos_list.find((item)=>{
        return item.value === val
			});
      this.selectCitySelo(select);
		}
  }
}
</script>

<style scoped>
.area_name {
    color: #222;
    font-family: "PT Root UI",sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
}
.area_address {
    color: rgba(34, 34, 34, 0.50);
    font-family: "PT Root UI",sans-serif;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    margin-bottom: 0;
}
.ant-table-tbody > tr > td {
    border: 1px solid #FFDFBD;
}
.areas_info ::v-deep .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table {
		border: 0;
}
.areas_info ::v-deep .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td {
    border: 1px solid #FFDFBD;
}

.areas_info ::v-deep .ant-table-content table tr:first-child td:first-child {
    border-top-left-radius: 12px;
}

.areas_info ::v-deep .ant-table.ant-table-bordered > .ant-table-container {
    border-left: 0;
}

.areas_info ::v-deep .ant-table-content table tr:first-child td:last-child {
    border-top-right-radius: 12px;
}

.areas_info ::v-deep .ant-table-content table tr:last-child td:first-child {
    border-bottom-left-radius: 12px;
}

.areas_info ::v-deep .ant-table-content table tr:last-child td:last-child {
    border-bottom-right-radius: 12px;
}



.areas_info ::v-deep .ant-table-cell {
		vertical-align: middle;
}

.type_show_offline {
    border-radius: 40px;
    background: #EC9850;
    color: #FFF;
    text-align: center;
    font-family: "PT Root UI",sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
		padding: 5px 15px;
}
.type_show_online {
    border-radius: 40px;
    background: #85B7A2;
    color: #FFF;
    text-align: center;
    font-family: "PT Root UI",sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    padding: 5px 15px;
}
.time_format {
    color: #EC9850;
    font-family: "PT Root UI",sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
}
.date_format {
    color: #222;
    font-family: "PT Root UI",sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
}
.before_select {
    color: #222;
    font-family: "PT Root UI",sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    margin-bottom: 5px !important;
}
.areas_info ::v-deep .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
		height: 50px;
		padding: 10px 11px;
		background: #F9F5F0;
		border-radius: 4px;
}

.content .areas_info ::v-deep  ul {
    margin-left: 0;
}

.area_show_wrapper {
    margin-top: 30px;
}
.areas_shows_wrapper .area_show_wrapper:first-child {
    margin-top: 25px;
}
.container .content  .areas_info ::v-deep h1 {
    color: #000;
    font-family: "PT Root UI",sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    margin-bottom: 10px;
}
.programm_description_wrapper {
    display: flex; align-items: center; justify-content: space-between
}
@media (max-width: 1000px) {
    .programm_description_wrapper {
				flex-wrap: wrap;
		}
		.type_show_offline {
        margin-top: 15px;
		}
    .type_show_online {
        margin-top: 15px;
    }
    .areas_info ::v-deep .ant-table-wrapper {
        overflow: scroll;
    }

    .areas_info ::v-deep .columns .column {
				padding-left: 0;
        padding-right: 0;
		}
}
</style>